<template>
  <b-row>
    <b-col cols="12">
      <karma-program-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaProgramEditForm from './KarmaProgramEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaProgramEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
